module.exports = __webpack_public_path__ + "img/144.3.599e2106.png";